import { withDefaultContextAsSelectedProject } from './api-default-context';
import { getStatementIdUtil } from 'utils/statement-export-utils';
import { getStore } from 'store/store';

export const sectionReviewRequest = ({ revisionId, sectionIds, isOCR }) => {
  const { selectedStatement } = getStore().getState().data;

  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/add/bookmarksReviewsBulk`
    : `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/add/sectionsReviewsBulk`;

  const postObj = {
    revisionId,
  };

  postObj[isOCR ? 'bookmarkIds' : 'sectionIds'] = sectionIds;

  return withDefaultContextAsSelectedProject().post(URL, postObj);
};

export const sectionUnReviewRequest = ({ revisionId, sectionIds, isOCR }) => {
  const { selectedStatement } = getStore().getState().data;

  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/delete/bookmarksReviewsBulk`
    : `/tieout/statements/${getStatementIdUtil(
        selectedStatement,
      )}/revisions/${revisionId}/delete/sectionsReviewsBulk`;

  const postObj = {
    revisionId,
  };

  postObj[isOCR ? 'bookmarkIds' : 'sectionIds'] = sectionIds;

  return withDefaultContextAsSelectedProject().post(URL, postObj);
};
